import { CircularProgress } from "@mui/material";

type SpinnerProps = {
    size?: number;
    className?: string;
}

export function Spinner({className , size = 15}: SpinnerProps) {
    return (
      <div className={`flex-1 align-center items-center text-center ${className}`}>
          <CircularProgress size={size} sx={{ color: '#52ae30' }} />
      </div>
    )
}
